import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import {
  flexSpaceBetweenCss,
  flexCentreAlignCss,
} from 'approot/shared/styles/flex.style';
import {
  grey2,
  orange1,
  orange9,
  red1,
  red9,
} from 'approot/shared/styles/colours.style';
import { font16 } from 'approot/shared/styles/typography.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { DRAW_TOOLBAR_Z_INDEX } from './draw-canvas.constants';

export const Draw = styled.div`
  background-color: ${grey2};
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const DrawBottomLeft = styled.div`
  ${flexSpaceBetweenCss}
  position: absolute;
  bottom: ${rem(spacing16)};
  left: ${rem(spacing16)};
  z-index: 1;
`;

export const DrawContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;

type DrawInterfaceProps = {
  $isInitialised: boolean;
};
export const DrawInterface = styled.div<DrawInterfaceProps>`
  background-color: ${grey2};
  flex-grow: 1;
  position: relative;
  overflow: hidden;

  opacity: 0;
  transition: opacity 200ms ease;

  ${({ $isInitialised }) =>
    $isInitialised &&
    `
    opacity: 1;  
  `}
`;

export const DrawCanvas = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
`;

type DrawBannerProps = {
  $isError: boolean;
};
export const DrawBanner = styled.div<DrawBannerProps>`
  ${font16}
  ${flexCentreAlignCss}
  
  background-color: ${orange1};
  color: ${orange9};
  padding: ${rem(spacing16)};
  position: relative;
  z-index: 1;

  ${({ $isError }) =>
    $isError &&
    `
      background-color: ${red1};
      color: ${red9};
  `}
`;

export const DrawCursorContainer = styled.div`
  display: none;
`;

export const DrawSubMenu = styled(Box)`
  z-index: ${DRAW_TOOLBAR_Z_INDEX + 1};
`;
